import React, { useState } from "react";
import { api, formatError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function Newsletter() {
  const [form, setForm] = useState({ email: "", name: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", form);
      setDone(true);
      toast.success("Subscribed — daily blessings begin tomorrow at dawn.");
    } catch (err) { toast.error(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="newsletter-page" className="min-h-[60vh] grid place-items-center px-4 py-14">
      <div className="w-full max-w-xl bg-[#FFFDF9] sacred-border rounded-3xl p-10 relative om-watermark">
        <Mail className="w-10 h-10 text-[#E65100]" />
        <div className="overline mt-5">Daily Blessing Newsletter</div>
        <h1 className="font-serif text-4xl text-[#4A0E17] mt-2">A verse at every sunrise.</h1>
        <p className="text-[#63534E] mt-4 leading-relaxed">
          Each morning, receive a short devotional verse, meaning, and reflection — carefully curated from the Shiva corpus. Unsubscribe anytime; no promotional noise.
        </p>
        {done ? (
          <div className="mt-7 bg-[#F3E5AB]/40 border border-[#D4AF37]/40 rounded-xl p-5 text-[#4A0E17]">
            🙏 You're subscribed. The first blessing will arrive at the next sunrise.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-7 space-y-4">
            <Input data-testid="newsletter-name" placeholder="Your name (optional)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-white border-[#D4AF37]/40 h-12" />
            <Input data-testid="newsletter-email" required type="email" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-white border-[#D4AF37]/40 h-12" />
            <Button data-testid="newsletter-submit" type="submit" disabled={loading} className="w-full bg-[#E65100] hover:bg-[#BF360C] rounded-full h-12 text-base">
              {loading ? "Subscribing…" : "Receive daily blessings"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
